import React from 'react';
import {Link} from 'react-router-dom';
import { Avatar, Button, Card, Col, Divider, Image, Row, Space, Typography } from 'antd';
import Sedgewick from './sedgewick.jpg';
const { Paragraph, Text, Title} = Typography;

const Home = () => {
    return <section className="centered-container">
        <br/><br/><br/>
        <div>
            <div className="home-page-landing">
                <Title >Learning is Visual, Immersive and Collaborative</Title>
                <Paragraph style={{fontSize: 15}}>
                Originated at Princeton University, the AI-driven CUbits video learning platform enables instructors to create visual, immersive, and collaborative leaning environments in minutes. Create supplemental, hybridor blended video learning opportunities to increase student engagement and accountability. Use real-time dashboards to know the progress of class, group and each student, any-time.
                </Paragraph>
                <br />
                <Button size="large" type="primary" style={{width: 200, fontSize: 15}}><a href="https://bit.ly/3L7ZTO2">Learn More</a></Button>
                <div style={{marginTop: 40}}>
                    <Space className="home-page-buttons ant-space-responsive">
                        <Button type="primary" style={{height: 40, fontSize: 15}}>
                            <a href="https://www.api.cubits.ai/accounts/signup">Build your own Collection for free</a>
                        </Button>
                        <Button type="primary" style={{height: 40, fontSize: 15}}>
                            <Link to="/aboutus/">Monetize your videos</Link>
                        </Button>
                        <Button type="primary" style={{height: 40, fontSize: 15}}>
                            <Link to="/collections/">Explore premium Collections</Link>
                        </Button>
                    </Space>
                </div>
            </div>
            <br/>
            <br/>
            <div className="testimonies-section">            
                <Card>
               
                   
                        
             
                        <Paragraph>
                            <blockquote style={{fontSize: 18}}>
                                “As technology provides compelling new opportunities for education, students need affordable access to curated content, teachers need flexible tools for aggregation and analytics, and content creators need wide distribution and fair compensation. CUbits.ai is a modern platform for all three, and now preferred for all of my online lectures.”
                            </blockquote>
                        </Paragraph>
                        <Space>
                            <Avatar size={60} src={<Image src={Sedgewick} style={{ width: 60 }} preview={false}/>} />
                            <Paragraph>
                                <Title level={5} style={{marginBottom: 0}}>Robert Sedgewick</Title> 
                                <Text type="secondary">Princeton University</Text>
                            </Paragraph>
                        </Space>
                        
                </Card>
                <Divider />
            </div>

        </div>
    </section>
}

export default Home;